module.exports = __webpack_public_path__ + "static/kinneth-2d45bfcf68f3af9b1a02e43e6a57af0b.jpg";